import { listConnectedCables } from "../utils/linkBoxFunctions";
import { Cable } from "../model/viewModel/cable";
import "./../App.css";
import { useSelector } from "react-redux";

interface StatusButtonProps {
  cableId: string;
  title: string;
  left: boolean;
  isClosed: boolean;
  linkBox: any;
  disabled?: boolean;
  updateNode: (newValue: any) => void;
}

const StatusButton = ({
  cableId,
  title,
  left,
  isClosed,
  linkBox,
  updateNode,
  disabled,
}: StatusButtonProps) => {
  const borderClass = cableId !== undefined ? (isClosed ? "border-success" : "border-danger") : "";

  return (
    <button
      type="button"
      onClick={() => {
        // Toggle the connectivity state of the cable
        if (cableId === undefined) return;

        const connectivity = { ...(linkBox.connectivity ?? { closed: [] }) };

        connectivity.closed = isClosed
          ? connectivity.closed.filter((c: any) => c !== cableId)
          : [...connectivity.closed, cableId];

        updateNode({ ...linkBox, connectivity });
      }}
      disabled={disabled || cableId === undefined}
      style={{ alignSelf: left ? "flex-end" : "flex-start" }}
      className={`d-flex align-items-center my-2 linkbox-connectivity-button ${
        left ? "flex-row" : "flex-row-reverse"
      }`}
      title={title}
    >
      <div className={`bg-dark p-2 text-light border ${borderClass} linkbox-status-title`}>
        {title}
      </div>
      {isClosed ? (
        <div className="bg-dark linkbox-correct" />
      ) : (
        <>
          <div className="bg-dark linkbox-start" />
          <div
            className="bg-dark linkbox-open-line"
            style={{
              transformOrigin: left ? "left" : "right",
            }}
          />
          <div className="bg-dark linkbox-end" />
        </>
      )}
    </button>
  );
};

interface LinkBoxConnectivityConfiguratorProps {
  clickedAsset: any;
  linkBox: any;
  updateNode: (newValue: any) => void;
  disabled?: boolean;
}

const LinkBoxConnectivityConfigurator = ({
  clickedAsset,
  linkBox,
  updateNode,
  disabled = false,
}: LinkBoxConnectivityConfiguratorProps) => {
  const cables = useSelector((state) => (state as any).network.present.cables);
  const cablesClosed = linkBox?.connectivity?.closed ?? [];
  const connectedCables = listConnectedCables(cables, clickedAsset) as {
    cable: Cable;
    cableId: string;
    title: string;
  }[];

  return (
    <>
      <div className="d-flex justify-content-center align-items-center flex-row">
        <div className="d-flex flex-column">
          {connectedCables
            .slice(0, 2)
            .map(({ cableId, title }: { cableId: string; title: string }, index: number) => (
              <StatusButton
                left={true}
                cableId={cableId}
                title={title}
                key={`connectivity_${index}`}
                isClosed={cablesClosed.includes(cableId)}
                linkBox={linkBox}
                updateNode={updateNode}
                disabled={disabled}
              />
            ))}
        </div>
        <div
          className="bg-dark"
          style={{
            width: 2,
            height: 160,
          }}
        />
        <div className="d-flex flex-column">
          {connectedCables
            .slice(2, 4)
            .map(({ cableId, title }: { cableId: string; title: string }, index: number) => (
              <StatusButton
                left={false}
                cableId={cableId}
                title={title}
                key={`connectivity_${index + 2}`}
                isClosed={cablesClosed.includes(cableId)}
                linkBox={linkBox}
                updateNode={updateNode}
                disabled={disabled}
              />
            ))}
        </div>
      </div>
    </>
  );
};

export default LinkBoxConnectivityConfigurator;
